import { render, staticRenderFns } from "./RoleViewDetails.vue?vue&type=template&id=5d37b3f4&"
import script from "./RoleViewDetails.vue?vue&type=script&lang=js&"
export * from "./RoleViewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports